(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bv-card-browse-intro"]) return;
  try {
    
(() => {
  if (customElements.get('bv-card-search')) return;
  class CardSearch extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const form = this.querySelector('form');
      form.addEventListener('submit', event => {
        event.preventDefault();
        const query = form.elements.q.value.trim();
        const current = new URL(location.href);
        const url = new URL(query ? form.action : form.dataset.bvStockUrl, location.origin);
        for (const [key,value] of current.searchParams) {
          if (key.startsWith('filter.') || key === 'preview_theme_id' || key === 'bv_sale' || key === 'bv_sort' || key === 'sort_by') url.searchParams.append(key,value);
        }
        if (query) {
          if (['manual','best-selling','created-ascending','created-descending'].includes(url.searchParams.get('sort_by'))) url.searchParams.delete('sort_by');
          url.searchParams.set('q',query);
          url.searchParams.set('type','product');
          url.searchParams.set('view','bv-cards');
          url.searchParams.set('options[prefix]','last');
        }
        location.assign(url);
      }, {signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('bv-card-search',CardSearch);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bv-category-section"] && !Shopify.designMode) return;
  try {
    
  if (!window.bvCategoryInteractions) {
    window.bvCategoryInteractions = true;
    document.addEventListener('input', (event) => {
      const stage = event.target.closest('.bv-category__stage');
      if (stage && event.target.matches('input[type="range"]')) stage.style.setProperty('--position', `${event.target.value}%`);
    });
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-bv-show]');
      if (!button) return;
      const gallery = button.closest('[data-bv-gallery]');
      gallery.querySelectorAll('[data-bv-pair]').forEach(pair => { pair.hidden = pair.dataset.bvPair !== button.dataset.bvShow; });
      gallery.querySelectorAll('[data-bv-show]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
